export const actionKey = '@@NETWORKBAR';
export const reduxKey = '@@NETWORKBAR';
export const watchedGroupsStreamId = 'NETWORKBAR_WATCHED_GROUPS';
export const recommendedGroupsStreamId = 'NETWORKBAR_RECOMMENDED_GROUPS';
export const grouphubId = 63289494;
